import React from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import moment from 'moment';

import {STRIPE_KEY} from "../../../config/custom";

export default function PaymentModule(props) {
    let userdata = JSON.parse(localStorage.getItem('userdata'));
    const yourDate = moment(userdata.created);
    // const isInDecember = yourDate.month() <= 3; 
    const isInDecember = (yourDate.month() <= 3 && (userdata.stripe_customer_id == "" || userdata.stripe_customer_id == null) && userdata.registration_source != "NEXGEN"); 
    // const isInDecember = (yourDate.month() <= 3 && userdata.has_trial_used == 0); 
    
    const stripePromise = loadStripe(STRIPE_KEY);

    return (
        <>
            <Row>
                <Col md={2}></Col>
                <Col md={9}>
                    <br />
                    <br />
                    {/* {isInDecember && <>
                        <h3>7 day FREE trial.</h3>
                        <p>Introductory offer for new members. Our free trial gives you access to Coach Master for 7 days, for absolutely nothing!</p>
                    </>} */}

                    <h2>
                        {/* Subscription */}
                         Pricing</h2>
                    {/* <p>Cancel your subscription any time</p> */}
                    
                    <h4>Monthly Subscription ${props.totalAmount}.00 /monthly</h4>
                    <ul style={{'list-style' : "none"}}>
                        <li><i className="fa fa-check" aria-hidden="true"></i> &nbsp;Join all webinar events</li>
                        <li> <i className="fa fa-check" aria-hidden="true"></i> &nbsp;Access all on-demand videos </li>
                        <li> <i className="fa fa-check" aria-hidden="true"></i> &nbsp;New live webinar events being scheduled every week </li>
                        <li><i className="fa fa-check" aria-hidden="true"></i> &nbsp;Explore inspiring speakers and life-enhancing coaches </li>
                        <li><i className="fa fa-check" aria-hidden="true"></i> &nbsp;Cancel your subscription any time </li>
                        
                    </ul>

                <div className='amp mt-5'>
                    <h2 style={{"font-size":"1.45rem"}}> 
                        Limited Time Offer <br />
                                {isInDecember ? <>
                                    <small>
                                <span style={{"color":"#000","font-size":"20px"}}>
                                    Get two months access for the price of one. <br />
                                    Subscribe and get your second month FREE
                            </span></small></> : 
                                 <><span style={{"color" : "#000"}}><small>One Month Access <br/><small>Standard Price <span ><s>${props.totalAmount}</s></span> US </small> </small></span></>
                            }
                            </h2>
                </div>
                <br />
                <div className='new_card' >
                    <div style={{"width":"500px"}}>
                    <Elements stripe={stripePromise}>
                        <CheckoutForm totalAmount={props.totalAmount} />
                    </Elements>
                    </div>
                </div>

                {/* <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <div className='new_card card p-3 mt-5'>
                        <strong><h4 style={{"font-size": "1.45rem"}}>Coach Master offers a <span style={{"color":"#00e1ba"}}>free 7 day trial </span> for first time users:</h4></strong>
                        <p style={{"text-align":"justify","font-size":"0.95rem"}}>Membership to Coach Master Services is one-month's access. Coach Master offers a free 7 day trial for first time purchases. Upon purchasing one-months access your card details are taken but no payment is taken. After the 7 day trial ends your card will be charged and you will receive access to our Services for 30 days. During the 7 day free trial you may cancel your purchase at any time and your card will not be charged and access to our Services will end immediately. Membership is billed on a one-month access only, i.e. it is not a rolling subscription. At the end of one-months access if you wish to continue to access Services you must re-enter your card details and purchase another month. There is no limit to how many purchases you can make.</p>
                    </div>
                    <br />
                    <br />
                    {isInDecember && <p>Members have access to all Services. Sign up to our 7 day free trial to unlock all features.</p> } */}

                </Col>
                </Row>
                </>
    )
}
